var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":(_vm.type)?_vm.type:'button',"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"inner"},[_vm._t("default")],2),_vm._v(" "),(_vm.icon)?_c('icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }